export const Blogs = (props) => {
    return (
      <div id='blogs'>
        <div className='container'>
          <div className='section-title text-center'>
            <h2>Blogs</h2>
          </div>
          <div className='row'>
            {props.data
              ? props.data.map((d, i) => (
                  <div key={`${d.author}-${i}`} className='col-md-12'>
                    <div className='blog'>
                      <div className='blog-title'>
                        <h3>{d.title}
                        <span style={{float:"right", color: "black"}}>{d.author} | {d.date}</span>
                        </h3>
                      </div>
                    </div>
                    <div className='blog-description'>
                        <p>{d.description}
                            <a href={d.link} target="blank"> Read more...</a> 
                        </p>
                    </div>
                  </div>
                ))
              : 'loading'}
          </div>
        </div>
      </div>
    )
  }
  